// The app's difficulty colours, in one place.
//
// Green -> Orange -> Red -> Maroon, i.e. an ordinal ramp that gets hotter as
// the question gets harder. Every screen that shows difficulty — question
// chips, the Test Score Summary breakdown, the difficulty-accuracy chart —
// reads from here, so the mapping cannot drift between them.
export const DIFFICULTY_COLORS = {
  Easy: "#15803D",        // green
  Medium: "#EA580C",      // orange
  Hard: "#DC2626",        // red
  "Very Hard": "#7F1D1D", // maroon
  Unknown: "#64748B",     // slate — not a difficulty, just unlabelled
};

// Display order, hardest last.
export const DIFFICULTY_ORDER = ["Easy", "Medium", "Hard", "Very Hard", "Unknown"];

export const difficultyColor = (level) => DIFFICULTY_COLORS[level] || DIFFICULTY_COLORS.Unknown;

export default DIFFICULTY_COLORS;
